import React from 'react'
import JdAi from '../Pages/PostJob/JdAi'

function PostJobAiText() {
  return (
    <>
        <JdAi />
    </>
  )
}

export default PostJobAiText
